import { render } from "./ProfileSection.vue?vue&type=template&id=7535124a&ts=true"
import script from "./ProfileSection.vue?vue&type=script&lang=ts"
export * from "./ProfileSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__